import React from "react";
import { CellTemplate, Compatible, Uncertain } from "@silevis/reactgrid";
import type { AddButtonCell } from "../../engine/cells";
import { GridAddAutocomplete } from "../../bidConsumer/components/GridAddAutocomplete";

export interface ServiceItem {
    name: string;
    internal_rate?: number | null;
    internal_markup?: number | null;
    [key: string]: unknown;
}

export class AddButtonCellTemplate implements CellTemplate<AddButtonCell> {
    constructor(
        private onAction: (action: string) => void,
        private serviceItems: ServiceItem[] = [],
    ) {}

    getCompatibleCell(
        uncertainCell: Uncertain<AddButtonCell>,
    ): Compatible<AddButtonCell> {
        const parentMetadata = uncertainCell.parentMetadata || {};
        const rowType = uncertainCell.rowType || "line";
        return {
            ...uncertainCell,
            parentMetadata,
            rowType,
            text: "",
            value: 0,
        };
    }

    render(
        cell: Compatible<AddButtonCell>,
        isInEditMode: boolean,
        onCellChanged: (
            cell: Compatible<AddButtonCell>,
            commit: boolean,
        ) => void,
    ): React.ReactNode {
        const serviceItemOptions = this.serviceItems.map((s) => s.name);
        const indent = (cell.indentLevel ? cell.indentLevel + 1 : 1) * 24 - 5;

        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: `${8 + indent}px`,
                    boxSizing: "border-box",
                }}
                onPointerDown={(e) => e.stopPropagation()} // Prevent ReactGrid from stealing focus from the Autocomplete
                onKeyDown={(e) => e.stopPropagation()}
            >
                <GridAddAutocomplete
                    type={cell.rowType}
                    serviceItemOptions={serviceItemOptions}
                    onAdd={(val) => {
                        let actionType = "";
                        if (cell.rowType === "section")
                            actionType = "ADD_ROOT_GROUP";
                        else if (cell.rowType === "category")
                            actionType = "ADD_SUBGROUP";
                        else actionType = "ADD_ITEM";
                        this.onAction(
                            `${actionType}:${cell.parentMetadata?.id || 0}:${val}`,
                        );
                    }}
                />
                <div style={{ flex: 1 }} />
            </div>
        );
    }
}
